import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@shared/guard/auth.guard';
import { AdminComponent } from './admin/admin.component';
import { ManageUsersComponent } from './admin/manage-users/manage-users.component';
import { PsrpsrGroupManageUserComponent } from './admin/psr-group-manage-users/psr-group-manage-user.component';
import { ActivityTackerComponent } from './audit-logs/activity-tacker/activity-tacker.component';
import { AuditLogsComponent } from './audit-logs/audit-logs.component';
import { ChangePriorTrackerComponent } from './audit-logs/change-prior-tracker/change-prior-tracker.component';
import { PsrPublishHistoryComponent } from './audit-logs/psr-publish-history/psr-publish-history.component';
import { ManageProductionEntityComponent } from './manage-production-entity/manage-production-entity.component';
import { ManageProjectsComponent } from './manage-projects/manage-projects.component';
import { ManagePublishDistComponent } from './manage-publish-dist/manage-publish-dist.component';
import { ManageReleaseDateComponent } from './manage-release-date/manage-release-date.component';
import { PicklistAdminComponent } from './picklist-admin/picklist-admin.component';

const routes: Routes = [
  { path: '', redirectTo: 'manage-publish-dist', pathMatch: 'full', canActivate: [AuthGuard], data: { pageName: "Admin"} },
  
  { path: 'user', component: AdminComponent, 
  children:[
    {path:'manage-user', component: ManageUsersComponent},
    {path:'psr-manage-user', component: PsrpsrGroupManageUserComponent}
  ], 
  canActivate: [AuthGuard], data: { pageName: "Admin"} 
},
  
  { path:'manage-projects', component: ManageProjectsComponent, canActivate: [AuthGuard], data: { pageName: "Admin"} },

  { path:'manage-publish-dist', component: ManagePublishDistComponent, canActivate: [AuthGuard], data: { pageName: "Admin"} },

  { path:'manage-production-entity', component: ManageProductionEntityComponent, canActivate: [AuthGuard], data: { pageName: "Admin"} },

  { path: 'audit-logs', component: AuditLogsComponent ,
    children:[
      {path:'', redirectTo:'psr-publish-history', pathMatch:'full'},
      {path:'psr-publish-history', component: PsrPublishHistoryComponent},
      {path:'activity-tracker', component: ActivityTackerComponent},
      {path:'change-prior-tracker', component: ChangePriorTrackerComponent}
    ], 
    canActivate: [AuthGuard], data: { pageName: "Admin"}
  },
  { path: 'manage-release-date', component: ManageReleaseDateComponent},
  { path:'pick-list', component: PicklistAdminComponent},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
